import { css } from '@emotion/react';
import { SvgIcon } from '@material-ui/core';
import { getIconComponent } from 'lib/icon';

const iconCss = css`
	&.MuiSvgIcon-root {
		font-size: 5rem;
		fill: none;
		margin-right: 8px;
	}
`;

const ConfirmationIcon = () => {
	const confirmationIconPath = 'confirmation';
	return <SvgIcon component={getIconComponent(confirmationIconPath)} viewBox="0 0 56 62" css={iconCss} />;
};

export default ConfirmationIcon;
